module.exports = __webpack_public_path__ + "static/media/SteeringFpIVizFlowOnly95.c593ad07.mp4";